module.exports = __webpack_public_path__ + "static/FormSearch-c3ae71ffb7c924be2fadd6593e9ed0fc.png";